import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { VacationKindPicker } from '../../../../components/entity-picker/vacation-kind-picker/VacationKindPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type IVacationKindFilterCardProps = {
  title: string;
  value: { id: number; name: string }[] | null;
  onChange: (value: { id?: number; name?: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const VacationKindFilterCard: React.FC<IVacationKindFilterCardProps> = (
  props
) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <VacationKindPicker
        multiple={true}
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
      />
    </FilterCard>
  );
};
